import React, { useEffect, useState } from "react";
import "../Styling/AttendanceSummary.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ClipboardList } from "lucide-react";

/* ================= Helpers ================= */
const getToday = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
};

const AttendanceSummary = ({ filters }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // ✅ prefer filter orgId, fallback to logged-in org
  const orgId = filters?.orgId || user?.organisationId;
  const companyCode = filters?.companyCode || "";
  const fiscalYear = filters?.fiscalYear || "";

  const date = getToday();

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= Fetch Attendance Summary ================= */
  useEffect(() => {
    if (!orgId) return;

    const fetchSummary = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams({
          organisationId: orgId,
          date
        });

        // optional wiring (future ready)
        if (companyCode) params.append("companyCode", companyCode);
        if (fiscalYear && fiscalYear !== "All Fiscal Years") {
          params.append("fiscalYear", fiscalYear);
        }

        const res = await fetch(
          `${Base_URL}/AttendanceReport/GetAttendanceSummary?${params.toString()}`
        );

        const data = await res.json();
        setSummary(data?.summary || null);
      } catch (err) {
        console.error("❌ Attendance summary error:", err);
        setSummary(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [orgId, companyCode, fiscalYear, date]); // 🔥 THIS is what wires it

  /* ================= UI ================= */
  if (loading) {
    return (
      <div className="attendance-summary-card">
        <div className="text-center text-muted py-3">
          Loading attendance summary…
        </div>
      </div>
    );
  }

  if (!summary) return null;

  return (
    <div className="attendance-summary-card">
      <div className="summary-header">
        <div className="header-left">
          <div className="summary-icon">
            <ClipboardList size={18} />
          </div>
          <h6>Attendance Summary</h6>
        </div>

        <span
          className="summary-view-link"
          onClick={() => navigate("/attendance-details")}
        >
          View Attendance Details
        </span>
      </div>

      <div className="row g-2 mt-2">
        {summary.total > 0 && <Stat label="Total" value={summary.total} color="total" />}
        {summary.present > 0 && <Stat label="Present" value={summary.present+summary.active} color="present" />}
        {summary.absent > 0 && <Stat label="Absent" value={summary.absent} color="absent" />}
        {/* {summary.active > 0 && <Stat label="Active" value={summary.active} color="active" />} */}
        {summary.late > 0 && <Stat label="Late" value={summary.late} color="late" />}
        {summary.halfDay > 0 && <Stat label="Half Day" value={summary.halfDay} color="halfday" />}
      </div>
    </div>
  );
};

/* ================= Stat Card ================= */
const Stat = ({ label, value, color }) => (
  <div className="col-6 col-md-4 col-lg-2">
    <div className={`summary-stat pastel-${color}`}>
      <h5>{value}</h5>
      <span>{label}</span>
    </div>
  </div>
);

export default AttendanceSummary;
